const preguntasObservaciones = [
  "SERVICIO REALIZADO",
  "SERVICIO CANCELADO",
  "USUARIO CONFIRMA RECOGIDA",
  "FAMILIAR CONFIRMA RECOGIDA",
  "SERVICIO VALIDADO GPS OK",
  "OPERADOR CONFIRMA RECOGIDA",
  "OPERADOR MICHEL CONFIRMA RECOGIDA",
  "RECOGIDA CON NOVEDAD:",
  "FAMILIAR NO SE ENCUENTRA EL USUARIO",
  "USUARIO NO CONTESTA, SE REALIZAN VARIAS LLAMADAS",
  "CELULAR DEL USUARIO APAGADO.",
  "SERVICIO VALIDADO POR GPS",
  "OPERADOR NO CONTESTA, SE REALIZAN VARIAS LLAMADAS",
  "OPERADOR CONFIRMA SERVICIOS ASIGNADOS DEL DD/MM/2025",
  "OPERADOR MICHEL CONFIRMA SERVICIOS ASIGNADOS DEL DD/MM/2025",
  "CELULAR DEL OPERADOR APAGADO.",
  "RECOGIDA NO SE REALIZA; NOVEDAD:",
  "(SERVICIO COMPARTIDO CON 00 USUARIOS)",
  "USUARIO NO HA SIDO RECOGIDO.",
  "RECOGIDA CON ATRASO DE 00h 00min",
  "USUARIO NO HA SALIDO DE LA UNIDAD MEDICA. SALIDA APROX.",
  "USUARIO SE DESPLAZA POR SUS PROPIOS MEDIOS, NOVEDAD:",
  "USUARIO REPORTA HORA DE RECOGIDA SOBRE LAS 00h 00min,",
  "OP CAMBIA HORA DE RECOGIDA SOBRE LAS 00h 00min,",
  "USUARIO CONFIRMA RECOGIDA CON MANEJO DE OP",
  "USUARIO CUMPLIO SU CITA - SERVICIO DE MANEJO INTERNO",
];

export default preguntasObservaciones;
